module.exports = __webpack_public_path__ + "img/sti-dest-active.270826bb.svg";